import { render, staticRenderFns } from "./giveLike.vue?vue&type=template&id=7c9ad2a3&scoped=true"
import script from "./giveLike.vue?vue&type=script&lang=js"
export * from "./giveLike.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/collection.css?vue&type=style&index=0&id=7c9ad2a3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9ad2a3",
  null
  
)

export default component.exports